import React from "react";
import Button from "../Button/Button";
import "./PopupBildButton.css";

const PopupBildButton = ({ label, onClick }) => {
  return (
    <Button className="PopupBildButton smaller" onClick={onClick}>
      {label}
    </Button>
  );
};

export default PopupBildButton;
